'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.publishTypicalResponseTimeMessage = undefined;

var _buildUnpublishedMessage = require('conversations-schema/factories/PubNubMessageFactory/buildUnpublishedMessage');

var _senderTypes = require('conversations-schema/pubnub-message/constants/senderTypes');

var _SenderIds = require('conversations-schema/constants/SenderIds');

var _TypicalResponseTimeMessageMetadata = require('conversations-schema/records/PubNubMessageMetadata/TypicalResponseTimeMessageMetadata');

var _TypicalResponseTimeMessageMetadata2 = _interopRequireDefault(_TypicalResponseTimeMessageMetadata);

var _getAvailabilityTypicalResponseTimeMessage = require('../availability/selectors/getAvailabilityTypicalResponseTimeMessage');

var _getWidgetTypicalResponseTime = require('./selectors/getWidgetTypicalResponseTime');

var _publishMessageToConversation = require('../actions/PublishActions/publishMessageToConversation');

var _trackInteraction = require('../usage-tracking/actions/trackInteraction');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var publishTypicalResponseTimeMessage = exports.publishTypicalResponseTimeMessage = function publishTypicalResponseTimeMessage(_ref) {
  var channel = _ref.channel,
      threadId = _ref.threadId;
  return function (dispatch, getState) {
    var message = (0, _buildUnpublishedMessage.buildUnpublishedMessage)({
      descriptor: {},
      metadata: (0, _TypicalResponseTimeMessageMetadata2.default)({
        text: (0, _getAvailabilityTypicalResponseTimeMessage.getAvailabilityTypicalResponseTimeMessage)(getState()),
        typicalResponseTime: (0, _getWidgetTypicalResponseTime.getWidgetTypicalResponseTime)(getState())
      }),
      senderId: _SenderIds.SYSTEM_ID,
      senderType: _senderTypes.SYSTEM,
      threadId: threadId
    });

    dispatch((0, _publishMessageToConversation.publishMessageToConversation)({ channel: channel, message: message, threadId: threadId }));

    dispatch((0, _trackInteraction.trackInteraction)('widget-interaction', {
      action: 'view reply time'
    }));
  };
};